import { useEffect, useState } from "react";

const navItems = [
  { label: "实时快讯", href: "#feed" },
  { label: "今日新料", href: "#today" },
  { label: "热榜", href: "#hot" },
  { label: "专题", href: "#topics" },
  { label: "为什么可信", href: "#trust" },
  { label: "常见问题", href: "#faq" },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b hairline"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-10 h-16 md:h-20 flex items-center justify-between gap-6">
        <div className="flex items-center gap-3 md:gap-4 min-w-0">
          <a href="#top" className="flex items-center gap-3 group">
            <span className="w-10 h-10 md:w-11 md:h-11 rounded-full bg-primary-500 text-background-50 flex items-center justify-center font-heading text-lg md:text-xl font-bold shrink-0">
              爱
            </span>
            <h1 className="font-heading text-xl md:text-2xl font-bold tracking-tight text-foreground-950 whitespace-nowrap">
              爱黑料网
            </h1>
          </a>
          <span className="hidden lg:flex items-center gap-2 pl-4 ml-1 border-l hairline">
            <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse-soft" />
            <span className="text-xs text-foreground-600 whitespace-nowrap">
              今日更新中 · 实时同步
            </span>
          </span>
        </div>

        <nav className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="px-3 py-2 rounded-md text-sm text-foreground-700 hover:text-primary-600 hover:bg-background-100 transition-colors whitespace-nowrap"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#feed"
            className="hidden md:inline-flex items-center gap-2 px-4 py-2.5 rounded-md bg-foreground-950 text-background-50 text-sm font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-flashlight-line text-base" />
            看最快黑料
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className="md:hidden w-10 h-10 rounded-md border hairline flex items-center justify-center text-foreground-800 cursor-pointer"
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t hairline bg-background-50/98 backdrop-blur-md px-4 py-3">
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMenuOpen(false)}
                className="py-3 border-b hairline last:border-b-0 text-sm text-foreground-800 hover:text-primary-600 transition-colors"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#feed"
              onClick={() => setMenuOpen(false)}
              className="mt-3 inline-flex items-center justify-center gap-2 px-4 py-3 rounded-md bg-foreground-950 text-background-50 text-sm font-medium"
            >
              <i className="ri-flashlight-line text-base" />
              看最快黑料
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}